import React from "react";
import _find from "lodash/find";
import { Translate } from "react-localize-redux";

function isContact(contactId, contacts) {
  if (contacts) {
    return _find(contacts, contact => contact.id === contactId);
  }
  return false;
}

function AddContactButton({ showButton, isUserLoggedIn, contactId, onAdd, onRemove, contacts }) {
  return (
    <React.Fragment>
      {showButton && isUserLoggedIn && (
        <React.Fragment>
          {!isContact(contactId, contacts) ? (
            <a
              className="btn search-table-btn grey-btn"
              onClick={() => onAdd(contactId)}
            >
              <Translate id="addText" />
            </a>
          ) : (
            <a
              className="btn search-table-btn grey-btn"
              onClick={() => onRemove(isContact(contactId, contacts).id)}
            >
              <Translate id="removeText" />
            </a>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default AddContactButton;



// WEBPACK FOOTER //
// ./src/components/AddContactButton/AddContactButton.js